import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import {
  ShowHiddenCondition,
  showHiddenOperator,
  ShowHiddenRuleModel,
  ShowHiddenRuleType,
  ShowHiddenSatisfyType
} from '../../types/control-show-hidden.types';
import { AbstractControl, ControlViewModel, ValueControlViewModel } from '../../types/control.types';
import { DynamicForm } from '../../types/dynamic-form.types';
import { findControlByName } from '../../utils/control-translate';
import { isEmptyInputValue } from '../../utils/utils';

export class ControlShowHiddenRule implements ShowHiddenRuleModel {
  dynamicForm: DynamicForm;
  controls: AbstractControl<ControlViewModel>[];
  showHiddenSatisfyType: ShowHiddenSatisfyType;
  showHiddenRuleType: ShowHiddenRuleType;
  targetControlsName: string[] = [];
  conditions: ShowHiddenCondition[] = [];
  targetControls: AbstractControl<ControlViewModel>[] = [];

  private _subs: Subscription = new Subscription();

  constructor() {}

  bind() {
    // åå§å targetControls
    this.targetControls = this.targetControlsName
      .map((s) => {
        return findControlByName(s, this.controls);
      })
      .filter((s) => s);
    // ç»å®æºåç®æ è§åï¼å¹¶æ§è¡ç­ç¥

    const conditions$ = this.conditions.map((s) => {
      // æ¾å°å¯¹åºæ§ä»¶
      return this.bindCondition(s);
    });

    combineLatest(conditions$).subscribe((s) => {
      let isSatisfy = false;
      if (this.showHiddenSatisfyType === ShowHiddenSatisfyType.All) {
        isSatisfy = s.every((satisfy) => satisfy);
      }

      if (this.showHiddenSatisfyType === ShowHiddenSatisfyType.Any) {
        isSatisfy = s.some((satisfy) => satisfy);
      }

      this.executeRule(isSatisfy);
    });
  }

  /**
   * è§£é¤ç»å®
   */
  unBind() {
    this._subs.unsubscribe();
  }

  bindCondition(condition: ShowHiddenCondition): Observable<boolean> {
    const result = new BehaviorSubject<boolean>(false);
    const control = findControlByName(condition.controlName, this.controls) as AbstractValueControlBase<
      ValueControlViewModel
    >;
    if (!control) {
      return result;
    }

    if (control instanceof AbstractValueControlBase) {
      // è¿æ ·é¡µé¢ä¸å è½½å°±å¯ä»¥å¤æ­äº
      result.next(this.isSatisfyCondition(control.model.value, condition));

      const sub = control.valueChanged$.subscribe((s) => {
        result.next(this.isSatisfyCondition(s.value, condition));
      });
      this._subs.add(sub);

      return result.asObservable();
    }
    console.warn(`å½åæ¾ç¤ºéèæ¡ä»¶æªå¹éå°${condition.controlName}çæ§ä»¶`);
    return result;
  }

  isSatisfyCondition(controlValue: any, condition: ShowHiddenCondition) {
    switch (condition.op) {
      case showHiddenOperator.Equal:
        return this.isEqual(controlValue, condition.value); // controlValue === condition.value;
      case showHiddenOperator.NotEqual:
        return !this.isEqual(controlValue, condition.value);
      case showHiddenOperator.Null:
        return isEmptyInputValue(controlValue);
      case showHiddenOperator.NotNull:
        return !isEmptyInputValue(controlValue);
    }
    return true;
  }

  executeRule(isSatisfy: boolean) {
    // å¯¹åºè¦æä½çæ§ä»¶
    this.targetControls.forEach((s) => {
      if (!s) {
        return;
      }
      const defaultHidden = s.model ? s.model.isHidden : false;

      let hidden = false;
      if (isSatisfy) {
        if (this.showHiddenRuleType === ShowHiddenRuleType.Show) {
          hidden = false;
        }
        if (this.showHiddenRuleType === ShowHiddenRuleType.Hidden) {
          hidden = true;
        }
      } else {
        hidden = defaultHidden;
      }

      this.dynamicForm.setControlHidden(s, hidden);
    });
  }

  isEqual(controlValue: any, conditionValue: any) {
    if (typeof controlValue === 'boolean') {
      const isConditionFalseValue = conditionValue === 'false' || conditionValue === '0' || !conditionValue;

      return controlValue === !isConditionFalseValue;
    }
    return controlValue === conditionValue;
  }
}
